const PageHeader = () => {
  const logoUrl = import.meta.env.VITE_HEADER_LOGO_URL;
  const logoUrl2 = import.meta.env.VITE_HEADER_LOGO_URL_2;
  const companyName = import.meta.env.VITE_COMPANY_NAME;

  return (
    <header className='lg:h-32 min-w-full flex items-center border p-4 lg:px-12'>
      <div>
        <a className='flex items-center justify-center demo-logo lg:gap-4'>
          {logoUrl && (
            <img
              className='h-16 lg:h-24'
              src={logoUrl}
              alt={`${companyName} logo`}
            />
          )}
          {logoUrl2 && (
            <img
              className='h-16 lg:h-24'
              src={logoUrl2}
              alt={`${companyName} secondary logo`}
            />
          )}
        </a>
      </div>
      {companyName && (
        <div className='lg:text-3xl lg:font-medium pl-1 lg:pl-4'>
          {companyName}
        </div>
      )}
    </header>
  );
};

export default PageHeader;
